
import { Vue, Component, Prop } from 'vue-property-decorator'
import CmsCarouselB from '@mg/web-components/Banners/CmsCarouselB'
import CmsCarouselA from '@mg/web-components/Banners/CmsCarouselA'
import {
  BannerData,
  CmsBannerAttributes,
} from '@mg/web-components/Banners/types'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'
import { GQLLocalAccount } from '~/graphql/__generated__/interfacesLocal'
import { GET_CONFIG } from '~/graphql/gql/config'
import { GET_BASIC_USER_INFO } from '~/graphql/gql/user'
import { GQLUser } from '~/graphql/__generated__/interfaces'
import AddToCartButton from '~/components/AddToCartButton.vue'
import showVipFeatures from '~/utils/showVipFeatures'
import getVipIcon from '~/utils/getVipIcon'
import { getRrpPrice } from '~/utils/productPriceSource'

@Component<CmsCarouselWithImage>({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    getConfig: {
      fetchPolicy: 'cache-only',
      query: GET_CONFIG,
    },
    user: {
      fetchPolicy: 'cache-only',
      query: GET_BASIC_USER_INFO,
      skip() {
        return !this.$shopConfig.user.id && !this.account?.isLogged
      },
    },
  },
  components: {
    AddToCartButton,
    CmsCarouselA,
    CmsCarouselB,
  },
})
export default class CmsCarouselWithImage extends Vue {
  @Prop(Boolean) compact: boolean
  @Prop(Boolean) isMobile: boolean
  @Prop(Object) bannerData: BannerData

  user: GQLUser
  account: GQLLocalAccount
  showVipFeatures = showVipFeatures
  getRrpPrice = getRrpPrice
  getVipIcon = getVipIcon

  get bannerAttributes() {
    return (this.bannerData.bannerAttributes || {}) as CmsBannerAttributes
  }

  get bannerVersion() {
    return this.bannerAttributes.version
  }

  get vipType() {
    return this.showVipFeatures(this.user?.vipType) ? this.user?.vipType : ''
  }

  get device() {
    return this.isMobile ? 'mobile' : 'desktop'
  }

  get cmsBannerType() {
    if (this.bannerVersion === 'A') {
      return 'CmsCarouselA'
    } else if (this.bannerVersion === 'B') {
      return 'CmsCarouselB'
    }
    return ''
  }

  get translations() {
    return {
      added: this.$t('common.cta_added'),
      buy_now: this.$t('common.cta_buy_now'),
      cta_information_more: this.$t('common.cta_information_more'),
      unit_price: this.$tc('common.unit_price'),
      vip_program_price: this.$t('common.vip_program_price_badge'),
    }
  }
}
